import inputMask from '../modules/inputMask';

export default () => {
    let $inputPhone = $('.form input[name="form[phone]"]');
    let $inputEmail = $('.form input[name="form[email]"]');

    inputMask($inputPhone, {
        'mask': '+7 (999) 999-99-99'
    });

    inputMask($inputEmail, {
        'mask': 'email'
    });
};


// WEBPACK FOOTER //
// ./templates/bazis/assets/js/jQueryApplication/components/form.js